import {FCX} from "@datassential/platform-ui-lib";
import {memo} from "react";

const AnalyzePerformanceFooterAction: FCX<{
    isLoading: boolean;
    loadReport: () => Promise<void>;
}> = ({
    isLoading,
    loadReport,
}) => {
    return (
        <>
            {isLoading ? (
                <div className="AnalyzePerformanceFooterAction">
                    DOWNLOADING
                    <div className="ProgressLoader"/>
                </div>
            ) : (
                <div
                    className="ActionButton"
                    onClick={loadReport}
                >
                    <div className="ActionButton__icon font-icons">&#59700;</div>
                    XLS REPORT
                </div>
            )}
        </>
    )
}

export default memo(AnalyzePerformanceFooterAction);